import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { IState, ISuccessAction, IFailureAction } from 'interfaces/list-duck';
import { CompanyDockOption } from 'interfaces/company-dock';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess'],
    success: ['data'],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'LIST_CompanyDocks_' }
);

export interface ListCompanyDocksState extends IState {
  data: CompanyDockOption[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: CompanyDockOption[];
}

const INITIAL_STATE: ListCompanyDocksState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListCompanyDocksState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: ListCompanyDocksState,
  action: ISuccessListUnitsAction
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListCompanyDocksState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listCompanyDocks = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListCompanyDocksTypes = Types;
export const ListCompanyDocksActions = Creators;
